// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"120":"6e8ffb8b","454":"4f0f346f","731":"7135b23b"}[chunkId] + ".css";
};